import {PanelTitleFn} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import {DebugKind, DebugWireContext} from '@mintdata-wsp/wsp/ui/views/visualDesigner/panels/debugData/DebugDataPanel';
import {DebugDataView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/panels/debugData/general/DebugDataView';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DebugWireView.less');
const cx = classnames.bind(styles);

export interface DebugWireViewProps extends PanelContentProps
{
    panelTitleFn:PanelTitleFn;
    context:DebugWireContext;
}

@observer
export class DebugWireView extends React.Component<DebugWireViewProps, any>
{
    render()
    {
        const {context, panelTitleFn} = this.props;
        const streamer = context.streamer;

        return  <div className={cx('debugWireView')}>
                    <DebugDataView label={null}
                                   kind={DebugKind.Wire}
                                   streamer={streamer}
                                   onPanelResize={this.props.onPanelResize}
                    />
                </div>;
    }
}
